import React, { useState, useEffect, version } from 'react';
import './ManageUsers.css'
import AuthService from './auth/AuthServices';

const UploadUpdate = () => {
  const [file, setFile] = useState(null);
  const [currentVersion, setCurrentVersion] = useState('')

  useEffect(() => {
    const checkCurrentVersion = async () => {
      const res = await AuthService.get_latest_version()
      if (res.ok) {
        const response = await res.json()
        setCurrentVersion(response.version)
      }
    }
    checkCurrentVersion()
  });

  const handleFileChange = (event, setFile) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!file) {
      alert('Bitte Datei auswählen')
    }
    const res = await AuthService.upload_new_file({
      file: file
    })
      if (res.ok) {
        const response = await res.json()
        console.log("Upload Success")
      } else {
        alert("Fehler beim Upload")
      }
  }

  return (
    <div className="container">
      <div className='main-container'>
        <h3>Bitte stellen Sie sicher, dass die Datei im Zip-Format vorliegt und das folgende Format als aktuelle Version hat.</h3>
        <p>Die letzte hochgeladene Version war {currentVersion}</p>
          <div className="file-upload">
            <div className="file-input">
                <label>Neue Version</label>
                  <div className="file-upload-wrapper">
                      <label className="file-upload-button" htmlFor="file">Datei auswählen</label>
                      <input id="file" type="file" onChange={(e) => handleFileChange(e, setFile)} required />
                      <span className="file-name">{file ? file.name : "Keine Datei ausgewählt"}</span>
                  </div>

                  <div className="buttons">
                      <button type="submit" className="file-upload-button" onClick={handleSubmit}>Hochladen</button>
                  </div>
            </div>
          </div>  
      </div>  
    </div>
  );
};

export default UploadUpdate;